/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.partners.orders.controllers', [])

.controller('PartnersOrdersController', ['$scope', function($scope) {

    $scope.partnersOrders = {

      model: "Your spankin new application.partners.orders.default view!",

      init: function() {},

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.partnersOrders.init();

}]);